export const validatePhoneNumber = (phoneNumber: string) => {
  if (!phoneNumber || phoneNumber.trim() === '') {
    return 'Please enter a valid phone number';
  }
  const regex = /^[0-9\-+()\s]+$/;
  if (!regex.test(phoneNumber)) {
    return 'Phone number contains invalid characters';
  }

  if (phoneNumber.length < 9 || phoneNumber.length > 11) {
    return 'Phone number must be at least 10 characters long';
  }

  return null;
};
